import React from "react";

import { aboutTitle } from "../../data/aboutData";
import { educationTitle } from "../../data/educationData";
import { experienceTitle } from "../../data/experienceData";
import { projectsTitle } from "../../data/projectsData";
import { personalTitle } from "../../data/personalData";


const Navbar = ({ activeSection }) => {
  return (
    <nav id="navbar">
      <ul>
        <li>
          <a href="#about" className={activeSection === "about" ? "active" : ""}>
            <span>{aboutTitle}</span>
          </a>
        </li>
        <li>
          <a href="#education" className={activeSection === "education" ? "active" : ""}>
            <span>{educationTitle}</span>
          </a>
        </li>
        <li>
          <a href="#experience" className={activeSection === "experience" ? "active" : ""}>
            <span>{experienceTitle}</span>
          </a>
        </li>
        <li>
          <a href="#projects" className={activeSection === "projects" ? "active" : ""}>
            <span>{projectsTitle}</span>
          </a>
        </li>
        <li>
          <a href="#personal" className={activeSection === "personal" ? "active" : ""}>
            <span>{personalTitle}</span>
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
